<template>
	<db-col width="auto" height="auto" valign="middle" class="radio-wrapper" :class="'radio-wrapper--' + disabled" @click="chose">
		<db-col class="circle ovh" :class="'circle--' + value" width="32" height="32" valign="middle" align="center">
			<db-icon icon="check" color="inherit" size="28" :class="'radio-icon--' + value" />
		</db-col>
		<db-col width="16" />
		<db-col height="auto" wrap width="auto" valign="middle" class="radio-text ovh">
			<slot></slot>
		</db-col>
	</db-col>
</template>

<script>
	export default {
		name: 'radio_',
		
		props: {
			value: {
				type: Boolean,
				default: false
			},
			
			disabled: {
				type: Boolean,
				default: false
			}
		},
		
		methods: {
			chose(){
				if(!this.disabled){
					this.$emit('input', !this.value)
				}
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	.radio-wrapper{
		.circle{
			border-radius: 100px;
			border: solid 2px #2e7bfd;
			color: transparent;
			transition: all .3s;
			
			&.circle--true{
				color: #fff;
				background: #2e7bfd;
			}
		}
		
		&.radio-wrapper--true{
			.circle{
				border-color: #CCCCCC;
				
				&.circle--true{
					background: #CCCCCC;
				}
			}
		}
	}
	
	.radio-icon--true{
		color: #fff;
	}
	
	.radio-text{
		font-size: 24px;
		max-width: 100%;
		color: inherit;
	}
</style>
